export const getRowClassName = (record) => {
  switch (record.status) {
    case "PENDING":
      return "table-row-pending";
    case "PROCESSING":
      return "table-row-processing";
    case "SUCCESS":
    case "PAID":
    case "success":
      return "table-row-success";
    case "MATCHED":
      return "table-row-success";
    case "REJECTED":
    case "not_found":
      return "table-row-rejected";
    case "IN_QUEUE":
      return "table-row-in_queue";
    case "INQ_MANUAL":
      return "table-row-in_MANUAL";
    case "VERRIFY_FAILED":
      return "table-row-geekblue";
    case "ERROR":
      return "table-row-rejected";
    case "expired":
      return "table-row-rejected";
    case "FAILED":
      return "table-row-rejected";
    case "active":
      return "table-row-processing";
    case "DUPLICATED":
      return "table-row-in_queue";
    case "NOT_MATCH":
      return "table-row-rejected";
    case "ONHOLD":
      return "table-row-geekblue";
    default:
      return "";
  }
};
export const getRowClassName2 = (record) => {
  switch (record.status) {
    case "PENDING":
      return "table-row-pending";
    case "PROCESSING":
      return "table-row-processing";
    case "success":
    case "SUCCESS":
      return "table-row-success";
    case "MATCHED":
      return "table-row-success";
    case "REJECTED":
      return "table-row-rejected";
    case "IN_QUEUE":
      return "table-row-in_queue";
    case "INQ_MANUAL":
      return "table-row-in_MANUAL";
    case "VERRIFY_FAILED":
      return "table-row-geekblue";
    case "ERROR":
      return "table-row-rejected";
    case "expired":
      return "table-row-rejected";
    case "FAILED":
      return "table-row-rejected";
    case "active":
      return "table-row-processing";
    case "DUPLICATED":
      return "table-row-in_queue";
    case "NOT_MATCH":
      return "table-row-rejected";
    case "ONHOLD":
      return "table-row-geekblue";
    default:
      return "";
  }
};
export const getRowStatus = (record) => {
  switch (record.status) {
    case "PENDING":
      return "table-row-pending out";
    case "FAILED":
    case "not_found":
      return "table-row-rejected out";
    case "success":
      return "table-row-success in";
    default:
      return "in";
  }
};

export const getTableRowClassName = (status) => {
  switch (status) {
    case "SUCCESS":
    case "success":
    case 1:
      return "in";
    default:
      return "out";
  }
};

export const getAlertClassName = (status) => {
  switch (status) {
    case "PENDING":
      return "warning";
    case "PROCESSING":
      return "info";
    case "SUCCESS":
      return "success";
    case "REJECTED":
      return "error";
    case "IN_QUEUE":
      return "table-row-in_queue in";
    case "ERROR":
      return "error";
    default:
      return "error";
  }
};
